import { getPageType, getPathName, PageTypes } from './pageTypes';
import { uniquePageId as id } from 'modules/activeWindow';
import { extractWorklistIds } from 'hooks/useWorklistId';
import { matchPaths } from './matchPaths';

export type PageType = {
  type: (typeof PageTypes)[keyof typeof PageTypes];
  id: string;
  createTimestamp: number;
  timestamp: number;
  windowId: Nullable<string>;
  url: string;
  worklistIds: Array<string>;
};

/** Returns the viewer window ID, `0` or `1` currently */
export const getWindowId = (urlOrPathname: string): string | undefined => {
  const pathname = getPathName(urlOrPathname);
  const viewerMatch = matchPaths(PageTypes.VIEWER, pathname);
  return viewerMatch?.params?.windowId;
};

// Constant time for when the page was originally created, even when
// refreshing the timestamp to maintain active tab states it will have a
// property to allow sorting by when they were created.
const creationTimestamp = Date.now();

export const getPage = (): PageType => ({
  type: getPageType(window.location.href),
  id,
  createTimestamp: creationTimestamp,
  timestamp: Date.now(),
  windowId: getWindowId(window.location.href),
  url: window.location.href,
  worklistIds: extractWorklistIds(window.location.pathname),
});
